import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { PageHeader } from "@/components/kit";
import { STEP_COMPONENTS, STEP_NAMES } from "@/components/checkin/CheckInSteps";
import { useCheckInForm } from "@/hooks/useCheckInForm";
import { useCustomItems } from "@/hooks/useCustomItems";
import { SnoozeBar } from "@/components/checkin/SnoozeBar";

const Progress = ({ step }) => (
  <div className="flex gap-1.5 mb-8">
    {STEP_NAMES.map((s, i) => <div key={s} className="h-1.5 flex-1 rounded-full transition-colors" style={{ background: i < step ? "var(--mm-primary)" : "var(--mm-surface-light)" }} />)}
  </div>
);

export default function CheckIn() {
  const nav = useNavigate();
  const [step, setStep] = useState(1);
  const toBody = useRef(false);
  const { f, set, busy, submit } = useCheckInForm(() => nav(toBody.current ? "/body-map?from=checkin" : "/"));
  const { items, saveItem } = useCustomItems();
  const Step = STEP_COMPONENTS[step - 1];
  const last = step === STEP_NAMES.length;
  const move = (d) => { setStep(step + d); window.scrollTo({ top: 0, behavior: "smooth" }); };

  return (
    <div className="max-w-3xl" data-testid="checkin-page">
      <PageHeader back title="Check-In" subtitle={`Step ${step} of ${STEP_NAMES.length} · ${STEP_NAMES[step - 1]}`} />
      <SnoozeBar />
      <Progress step={step} />
      <div className="mm-card p-6 sm:p-8 mm-fade-up" key={step}>
        <Step f={f} set={set} items={items} saveItem={saveItem} />
      </div>
      <div className="flex justify-between mt-6">
        <button className="mm-btn-ghost" disabled={step === 1} onClick={() => move(-1)} data-testid="checkin-prev-button" style={{ visibility: step === 1 ? "hidden" : "visible" }}>Back</button>
        {last ? (
          <div className="flex flex-wrap justify-end gap-2">
            <button className="mm-btn-ghost" onClick={() => { toBody.current = true; submit(); }} disabled={busy} data-testid="checkin-submit-bodymap-button">Complete + map my body</button>
            <button className="mm-btn" onClick={() => { toBody.current = false; submit(); }} disabled={busy} data-testid="checkin-submit-button">{busy && <Loader2 size={16} className="animate-spin" />}Complete Check-In</button>
          </div>
        ) : (
          <button className="mm-btn" onClick={() => move(1)} data-testid="checkin-next-button">Continue</button>
        )}
      </div>
    </div>
  );
}
